'use strict'

class Swatch {
    constructor(_obj) {
        this.id = _obj.id
        this.name = _obj.name
        this.color_per_page = _obj.color_per_page
        this.type = _obj.type
    }
}

export default Swatch
